// src/graphql/queries/companyQueries.js
import { fingerprintFields } from '../fragments';

export const getCompanies = () => `query GetCompanies($active: Boolean, $limit: Int, $offset: Int) {
    adminCompanies(active: $active, limit: $limit, offset: $offset) {
        id
        name
        size
        industry
        location {
            address
            city
            state
            postalCode
            country
            nutsCode
            latitude
            longitude
        }
        website
        description
        active
        createdAt
        updatedAt
        users {
            id
            email
            firstName
            lastName
            role
            active
            isCompanyRepresentative
        }
        subscription {
            id
            tier
            status
            startDate
            endDate
        }
        maxUsers
        pendingInvitationsCount
        pendingReferralsCount
    }
}`;

export const getCompany = () => `query GetCompany($id: String!) {
    adminCompany(id: $id) {
        id
        name
        size
        industry
        location {
            address
            city
            state
            postalCode
            country
            nutsCode
            latitude
            longitude
        }
        website
        description
        active
        createdAt
        updatedAt
        users {
            id
            email
            firstName
            lastName
            role
            active
            lastLogin
            isCompanyRepresentative
        }
        subscription {
            id
            tier
            status
            billingCycle
            price
            startDate
            endDate
        }
        maxUsers
        pendingInvitationsCount
        pendingReferralsCount
        fingerprint {
            ${fingerprintFields}
        }
    }
}`;

export const getCompanyFingerprint = () => `query GetCompanyFingerprint($companyId: String!) {
    companyFingerprint(companyId: $companyId) {
        ${fingerprintFields}
    }
}`;
